// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import { CoachGoalSpecificOutcomesCoachFragmentDoc } from './CoachGoalSpecificOutcomes.generated';
export type CoachCategorySpecificInfoCoachFragment = {
  __typename?: 'Coach';
  id: string;
  professionalCoach: boolean;
  openToInternational: boolean;
  user: { __typename?: 'User'; id: string; firstName: string };
  outcomes?: Array<
    | {
        __typename?: 'CareerOutcomeSummary';
        number: number;
        companies: Array<{
          __typename?: 'Company';
          id?: string | null;
          name: string;
          logoLink?: string | null;
        }>;
      }
    | {
        __typename?: 'SchoolOutcomeSummary';
        number: number;
        schools: Array<{
          __typename?: 'School';
          id: string;
          name: string;
          logoLink?: string | null;
        }>;
      }
    | {
        __typename?: 'TestOutcomeSummary';
        scoreRange?: string | null;
        number: number;
        category: { __typename?: 'Category'; id: string; name: string };
      }
  > | null;
};

export type CoachCategorySpecificInfoCategoryInfoFragment = {
  __typename?: 'CategoryInformation';
  testScore?: number | null;
  experienceLevel?: number | null;
  customersCoached?: number | null;
  qualifications?: string | null;
  category: {
    __typename?: 'Category';
    id: string;
    name: string;
    goal: Types.GoalName;
  };
};

export const CoachCategorySpecificInfoCoachFragmentDoc = gql`
  fragment CoachCategorySpecificInfo_Coach on Coach {
    id
    professionalCoach
    openToInternational
    ...CoachGoalSpecificOutcomes_Coach
  }
  ${CoachGoalSpecificOutcomesCoachFragmentDoc}
`;
export const CoachCategorySpecificInfoCategoryInfoFragmentDoc = gql`
  fragment CoachCategorySpecificInfo_CategoryInfo on CategoryInformation {
    category {
      id
      name
      goal
    }
    testScore
    experienceLevel
    customersCoached
    qualifications
  }
`;
